<template>
    <div class="cebc">
        <Header></Header>
        <div class="cebc-banner flex-row">
            <div class="flex-col container banner-title">
                <p class="main-title">日本CEBC公司</p>
                <p class="sub-title">专业提供低空航空器、氢动力自行车研发及销售和服务的高新技术企业</p>
            </div>
        </div>
        <div class="cebc-content flex-col">
            <img src="@/assets/images/cebc/content-1.jpeg" alt="">
            <img src="@/assets/images/cebc/content-2.jpeg" alt="">
            <img src="@/assets/images/cebc/content-3.jpeg" alt="">
            <img src="@/assets/images/cebc/content-4.jpeg" alt="">
            <img src="@/assets/images/cebc/content-5.jpeg" alt="">
            <img src="@/assets/images/cebc/content-6.jpeg" alt="">
            <img src="@/assets/images/cebc/content-7.jpeg" alt="">

        </div>

        <Footer></Footer>
    </div>
</template>

<script>
import '@/assets/css/cebc.css'
import Header from './Header'
import Footer from './Footer'
export default {
    components: {
        Header, Footer
    },
    name: 'Cebc',


}
</script>


// WEBPACK FOOTER //
// src/components/CEBC.vue